<template>
  <section class="form-list">
    <el-form
      class="form"
      ref="form"
      :rules="rules"
      :model="appPage"
      label-position="right"
      label-width="130px"
    >
      <el-form-item label="页面名称" prop="page_name">
        <el-input
          v-model="appPage.page_name"
          maxlength="32"
          show-word-limit
          clearable
          placeholder="请输入小程序页面名称"
        />
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="handleSubmit" :loading="isSaving">保存修改</el-button>
        <el-button @click="RouteConfig.appPageList.back">取消</el-button>
      </el-form-item>
    </el-form>
  </section>
</template>

<script>
import RouteConfig from '@/router/config';
import { show, update } from '@/api/app-page';

export default {
  name: RouteConfig.appPageEdit.name,
  data: () => ({
    RouteConfig,
    isSaving: false,
    appPage: {
      page_name: '',
      update_time: 0,
    },
    rules: {
      page_name: [{ required: true, message: '请输入页面名称', trigger: 'change' }],
    },
  }),
  computed: {
    id() {
      return +this.$route.params.id || 0;
    },
  },
  beforeMount() {
    this.show();
  },
  methods: {
    handleSubmit() {
      if (this.isSaving) return;

      this.$refs.form.validate(async (isSuccess) => {
        if (!isSuccess) return;

        this.isSaving = true;
        const postData = { ...this.appPage };
        const { isError } = await update(this.id, postData);
        this.isSaving = false;
        if (!isError) RouteConfig.appPageList.back();
      });
    },
    async show() {
      const { isError, data } = await show(this.id);
      if (isError) return;

      const { appPage } = this;
      const appPageInfo = {};
      Object.keys(data).forEach(key => {
        if (key in appPage) appPageInfo[key] = data[key];
      });
      Object.assign(appPage, appPageInfo);
    },
  },
};
</script>
